import { BoxOfferSlideCardsView } from "@modules/boxOffer/components/boxOfferCardsView"
import { BoxOfferForm } from "@modules/boxOffer/components/boxOfferForm"
import { BoxOfferOrderForm } from "@modules/boxOffer/components/boxOfferOrderForm"
import { BoxOfferResumeView } from "@modules/boxOffer/components/boxOfferResumeView"
import { BoxOfferDetailedEntity } from "@modules/boxOffer/entities/boxOfferEntity"
import { BoxOfferType } from "@modules/boxOffer/entities/boxOfferTypes"
import { word } from "@modules/core/utils/i18n"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { useConfirmPopup } from "@modules/ui/components/popup/huConfirmPopup"
import { ErrorBoundary } from "react-error-boundary"
import { ErrorView } from "@/components/ui/layout/error/errorView"
import { Suspense } from "react"
import { LoadingSpinner } from "@/modules/ui/components/loading"

export const useBoxOfferSidebar = () => {
  const { sidebarNavigateTo, sidebarNavigateBack, hideSidebar, isSidebarVisible } = useSidebar()
  const confirmPopup = useConfirmPopup()

  const navigateToBoxOfferCards = (selectedType?: BoxOfferType) =>
    sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxOfferSlideCardsView selectedType={selectedType} />
          </Suspense>
        </ErrorBoundary>
      ),
      replaceAllComponents: true,
    })

  const navigateToBoxOfferForm = (
    boxOfferType?: BoxOfferType,
    boxOffer?: BoxOfferDetailedEntity,
    isArchiveEdition?: boolean,
  ) =>
    sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxOfferForm selectedType={boxOfferType} offer={boxOffer} isArchiveEdition={isArchiveEdition} />
          </Suspense>
        </ErrorBoundary>
      ),
      replaceAllComponents: true,
      onHide: async () =>
        await new Promise<boolean>((resolve) => {
          confirmPopup.show({
            title: boxOffer
              ? word("box.offer.form.cancel.edition.title")
              : word("box.offer.form.cancel.creation.title"),
            message: word("box.offer.form.cancel.edition.description"),
            accept: () => {
              return Promise.resolve(void resolve(true))
            },
            cancel: () => {
              return Promise.resolve(void resolve(false))
            },
          })
        }),
    })

  const navigateToBoxOfferResume = (offerId: string) =>
    sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxOfferResumeView offerId={offerId} />
          </Suspense>
        </ErrorBoundary>
      ),
      replaceAllComponents: true,
    })

  const navigateToBoxOfferOrderForm = () =>
    sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxOfferOrderForm />
          </Suspense>
        </ErrorBoundary>
      ),
      replaceAllComponents: true,
    })

  return {
    navigateToBoxOfferCards,
    sidebarNavigateBack,
    hideSidebar,
    navigateToBoxOfferResume,
    navigateToBoxOfferForm,
    navigateToBoxOfferOrderForm,
    isSidebarVisible,
  }
}
